/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as RepoDefs from './defs.defs.js'

const $nsid = 'com.atproto.repo.applyWrites'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  repo: /*#__PURE__*/ l.string({ format: 'at-identifier' }),
  writes: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.typedUnion(
      [
        /*#__PURE__*/ l.typedRef<Create>((() => create) as any),
        /*#__PURE__*/ l.typedRef<Update>((() => update) as any),
        /*#__PURE__*/ l.typedRef<Delete$0>((() => delete$0) as any),
      ],
      true,
    ),
  ),
  validate: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
  swapCommit: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ format: 'cid' }),
  ),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.jsonPayload({
  commit: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.ref<RepoDefs.CommitMeta>(
      (() => RepoDefs.commitMeta) as any,
    ),
  ),
  results: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.typedUnion(
        [
          /*#__PURE__*/ l.typedRef<CreateResult>((() => createResult) as any),
          /*#__PURE__*/ l.typedRef<UpdateResult>((() => updateResult) as any),
          /*#__PURE__*/ l.typedRef<DeleteResult>((() => deleteResult) as any),
        ],
        true,
      ),
    ),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Apply a batch transaction of repository creates, updates, and deletes. Requires auth, implemented by PDS. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output, [
  'InvalidSwap',
])

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }

/** Operation which creates a new record. */
type Create = {
  $type?: 'com.atproto.repo.applyWrites#create'

  /**
   * NOTE: maxLength is redundant with record-key format. Keeping it temporarily to ensure backwards compatibility.
   */
  rkey?: l.RecordKeyString
  value: l.LexMap
  collection: l.NsidString
}

export type { Create }

/** Operation which creates a new record. */
const create = /*#__PURE__*/ l.typedObject<Create>(
  $nsid,
  'create',
  /*#__PURE__*/ l.object({
    rkey: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'record-key', maxLength: 512 }),
    ),
    value: /*#__PURE__*/ l.lexMap(),
    collection: /*#__PURE__*/ l.string({ format: 'nsid' }),
  }),
)

export { create }

/** Operation which deletes an existing record. */
type Delete$0 = {
  $type?: 'com.atproto.repo.applyWrites#delete'
  rkey: l.RecordKeyString
  collection: l.NsidString
}

export type { Delete$0 as Delete }

/** Operation which deletes an existing record. */
const delete$0 = /*#__PURE__*/ l.typedObject<Delete$0>(
  $nsid,
  'delete',
  /*#__PURE__*/ l.object({
    rkey: /*#__PURE__*/ l.string({ format: 'record-key' }),
    collection: /*#__PURE__*/ l.string({ format: 'nsid' }),
  }),
)

export { delete$0 as 'delete' }

/** Operation which updates an existing record. */
type Update = {
  $type?: 'com.atproto.repo.applyWrites#update'
  rkey: l.RecordKeyString
  value: l.LexMap
  collection: l.NsidString
}

export type { Update }

/** Operation which updates an existing record. */
const update = /*#__PURE__*/ l.typedObject<Update>(
  $nsid,
  'update',
  /*#__PURE__*/ l.object({
    rkey: /*#__PURE__*/ l.string({ format: 'record-key' }),
    value: /*#__PURE__*/ l.lexMap(),
    collection: /*#__PURE__*/ l.string({ format: 'nsid' }),
  }),
)

export { update }

type CreateResult = {
  $type?: 'com.atproto.repo.applyWrites#createResult'
  cid: l.CidString
  uri: l.AtUriString
  validationStatus?: 'valid' | 'unknown' | l.UnknownString
}

export type { CreateResult }

const createResult = /*#__PURE__*/ l.typedObject<CreateResult>(
  $nsid,
  'createResult',
  /*#__PURE__*/ l.object({
    cid: /*#__PURE__*/ l.string({ format: 'cid' }),
    uri: /*#__PURE__*/ l.string({ format: 'at-uri' }),
    validationStatus: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string<{ knownValues: ['valid', 'unknown'] }>(),
    ),
  }),
)

export { createResult }

type DeleteResult = { $type?: 'com.atproto.repo.applyWrites#deleteResult' }

export type { DeleteResult }

const deleteResult = /*#__PURE__*/ l.typedObject<DeleteResult>(
  $nsid,
  'deleteResult',
  /*#__PURE__*/ l.object({}),
)

export { deleteResult }

type UpdateResult = {
  $type?: 'com.atproto.repo.applyWrites#updateResult'
  cid: l.CidString
  uri: l.AtUriString
  validationStatus?: 'valid' | 'unknown' | l.UnknownString
}

export type { UpdateResult }

const updateResult = /*#__PURE__*/ l.typedObject<UpdateResult>(
  $nsid,
  'updateResult',
  /*#__PURE__*/ l.object({
    cid: /*#__PURE__*/ l.string({ format: 'cid' }),
    uri: /*#__PURE__*/ l.string({ format: 'at-uri' }),
    validationStatus: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string<{ knownValues: ['valid', 'unknown'] }>(),
    ),
  }),
)

export { updateResult }
